export default [
  {
    path: "/axo-dashboard",
    name: "axo-main",
    component: () =>
      import("../../modules/AXO/pages/AxoDashboard/AxoDashboard2.vue"),
    meta: {
      layout: "main",
      auth: true,
      role: ["axo"],
    },
  },
];
